import { ThemeKey } from '@/contexts/ThemeContext';

export interface ThemeMetadata {
  key: ThemeKey;
  name: string;
  description: string;
  inspiration: string;
}

export const THEME_METADATA: Record<ThemeKey, ThemeMetadata> = {
  default: {
    key: 'default',
    name: 'Default',
    description: 'Neutral professional theme',
    inspiration: 'Clean and accessible baseline'
  },
  army: {
    key: 'army',
    name: 'Army',
    description: 'Army dress uniform inspired',
    inspiration: 'Gold on Near-Black'
  },
  navy: {
    key: 'navy',
    name: 'Navy',
    description: 'Navy dress uniform inspired',
    inspiration: 'Navy Blue and Gold'
  },
  marines: {
    key: 'marines',
    name: 'Marine Corps',
    description: 'Marine Corps dress uniform inspired',
    inspiration: 'Scarlet and Gold on charcoal'
  },
  airforce: {
    key: 'airforce',
    name: 'Air Force',
    description: 'Air Force dress uniform inspired',
    inspiration: 'Air Force Blue and Silver'
  },
  spaceforce: {
    key: 'spaceforce',
    name: 'Space Force',
    description: 'Space Force dress uniform inspired',
    inspiration: 'Vibrant Orange and Gold'
  },
  coastguard: {
    key: 'coastguard',
    name: 'Coast Guard',
    description: 'Coast Guard dress uniform inspired',
    inspiration: 'Coast Guard Blue with Red Racing Stripe'
  },
  other: {
    key: 'other',
    name: 'Other',
    description: 'Subtle neutral theme',
    inspiration: 'Professional and understated'
  }
};

export function getThemeList(): ThemeMetadata[] {
  return Object.values(THEME_METADATA);
}
